import { Route } from '@angular/router';
import { canMatchByRole } from './core/auth/guards/can-match-by-role.guard';
import { canMatchCustomerFeature } from './core/customer/customer-feature.guard';

export const aquacultureChildren: Route[] = [
  {
    path: '',
    redirectTo: 'dashboards/cte-control-center',
    pathMatch: 'full',
  },
  {
    path: 'user-profile',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'user-profile' },
    loadChildren: () => import('app/modules/user-profile/user-profile.routes').then((m) => m.userProfileRoutes),
  },
  {
    path: 'dashboards',
    redirectTo: 'dashboards/cte-control-center',
    pathMatch: 'full',
  },
  {
    path: 'dashboards/cte-control-center',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'control-center' },
    loadChildren: () => import('app/modules/dashboards/cte-control-center.routes').then((m) => m.cteControlCenterRoutes),
  },
  {
    path: 'dashboards/overview',
    loadComponent: () => import('app/modules/dashboards/Ribena/overview/overview.component').then((c) => c.OverviewComponent),
  },
  {
    path: 'traceability/lot-trace-discovery',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY'], featureKey: 'lot-tracing' },
    loadChildren: () => import('app/modules/tools-reports/lot-trace-discovery/lot-trace-discovery.routes').then((m) => m.lotTraceDiscoveryRoutes),
  },
  {
    path: 'traceability/event-summary',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'event-summary' },
    loadChildren: () => import('app/modules/tools-reports/event-summary/event-summary.routes').then((m) => m.eventSummaryRoutes),
  },
  {
    path: 'traceability/lot-tracing',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY'], featureKey: 'lot-tracing' },
    loadChildren: () => import('app/modules/tools-reports/traceability/traceability.routes').then((m) => m.traceabilityRoutes),
  },
  {
    path: 'traceability/lot-sharing',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY'], featureKey: 'lot-sharing' },
    loadChildren: () => import('app/modules/tools-reports/lot-sharing/lot-sharing.routes').then((m) => m.lotSharingRoutes),
  },
  {
    path: 'ctes/hatching',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'aqua.hatching' },
    loadChildren: () => import('app/modules/CTEs/hatching/hatching.routes').then((m) => m.hatchingRoutes),
  },
  {
    path: 'ctes/feed-mill',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'aqua.feed-mill' },
    loadChildren: () => import('app/modules/CTEs/feed-mill/feed-mill.routes').then((m) => m.feedMillRoutes),
  },
  {
    path: 'ctes/feeding',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'aqua.feeding' },
    loadChildren: () => import('app/modules/CTEs/feeding/feeding.routes').then((m) => m.feedingRoutes),
  },
  {
    path: 'ctes/harvest',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'aqua.harvest' },
    loadChildren: () => import('app/modules/CTEs/harvest/harvest.routes').then((m) => m.harvestRoutes),
  },
  {
    path: 'ctes/transfer',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'aqua.transfer' },
    loadChildren: () => import('app/modules/CTEs/transfer/transfer.routes').then((m) => m.transferRoutes),
  },
  {
    path: 'ctes/receipt',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'aqua.receipt' },
    loadChildren: () => import('app/modules/CTEs/receive/receive.routes').then((m) => m.receiveRoutes),
  },
  {
    path: 'ctes/aggregation',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'aqua.aggregation' },
    loadChildren: () => import('app/modules/CTEs/aggregation/aggregation.routes').then((m) => m.aggregationRoutes),
  },
  {
    path: 'ctes/disaggregation',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'aqua.disaggregation' },
    loadChildren: () => import('app/modules/CTEs/disaggregation/disaggregation.routes').then((m) => m.disaggregationRoutes),
  },
  {
    path: 'ctes/shipping',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'aqua.shipping' },
    loadChildren: () => import('app/modules/CTEs/shipping/shipping.routes').then((m) => m.shippingRoutes),
  },
  {
    path: 'ctes/processing',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'aqua.processing' },
    loadChildren: () => import('app/modules/CTEs/processing/processing.routes').then((m) => m.processingRoutes),
  },
  {
    path: 'ctes/cold-storage',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'aqua.cold-storage' },
    loadChildren: () => import('app/modules/CTEs/cold-storage/cold-storage.routes').then((m) => m.coldStorageRoutes),
  },
  // {
  //   path: 'aux/hatchery',
  //   canMatch: [canMatchCustomerFeature, canMatchByRole],
  //   data: { roles: [], featureKey: 'aux.hatchery' },
  //   loadChildren: () => import('app/modules/auxiliary-data/hatchery-data/hatchery-data.routes').then((m) => m.hatcheryDataRoutes),
  // },
  {
    path: 'aux/cn-data',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'aux.cn-data' },
    loadChildren: () => import('app/modules/auxiliary-data/cn-data/cn-data.routes').then((m) => m.cnDataRoutes),
  },
  {
    path: 'aux/feed-sku',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'aux.feed-sku' },
    loadChildren: () => import('app/modules/auxiliary-data/feed-mill-data/feed-mill-data.routes').then((m) => m.feedMillDataRoutes),
  },
  {
    path: 'aux/feeding',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'aux.feeding' },
    loadChildren: () => import('app/modules/auxiliary-data/feeding/feeding-data.routes').then((m) => m.feedingDataRoutes),
  },
  {
    path: 'aux/raceway',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'aux.raceway' },
    loadChildren: () => import('app/modules/auxiliary-data/raceway-details/raceway-details.routes').then((m) => m.racewayDetailsRoutes),
  },
  {
    path: 'aux/cage-details',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'aux.cage-details' },
    loadChildren: () => import('app/modules/auxiliary-data/cage-details/cage-details.routes').then((m) => m.cageDetailsRoutes),
  },
  {
    path: 'aux/vehicle',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'aux.vehicle' },
    loadChildren: () => import('app/modules/auxiliary-data/vehicle-data/vehicle-data.routes').then((m) => m.vehicleDataRoutes),
  },
  {
    path: 'aux/vessel',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'aux.vessel' },
    loadChildren: () => import('app/modules/auxiliary-data/vessel-data/vessel-data.routes').then((m) => m.vesselDataRoutes),
  },
  {
    path: 'master/species',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'master.species' },
    loadChildren: () => import('app/modules/master-data/species/species.routes').then((m) => m.speciesRoutes),
  },
  {
    path: 'master/parties',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'master.parties' },
    loadChildren: () => import('app/modules/master-data/parties/parties.routes').then((m) => m.partiesRoutes),
  },
  {
    path: 'master/locations',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'master.locations' },
    loadChildren: () => import('app/modules/master-data/locations-data/location-data.routes').then((m) => m.locationRoutes),
  },
  {
    path: 'master/port-areas',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'master.port-areas' },
    loadChildren: () => import('app/modules/master-data/port-areas/port-areas.routes').then((m) => m.portAreasRoutes),
  },
  {
    path: 'master/personnel',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'master.personnel' },
    loadChildren: () => import('app/modules/master-data/personnel/personnel.routes').then((m) => m.personnelRoutes),
  },
  // {
  //   path: 'master/skus',
  //   canMatch: [canMatchCustomerFeature, canMatchByRole],
  //   data: { roles: [], featureKey: 'master.skus' },
  //   loadChildren: () => import('app/modules/master-data/product-sku/product-sku.routes').then((m) => m.productSkuRoutes),
  // },
  {
    path: 'master/certification-data',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY'], featureKey: 'master.certification-data' },
    loadChildren: () => import('app/modules/master-data/certification-data/certification-data.routes').then((m) => m.certificationDataRoutes),
  },
  {
    path: 'settings/users',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY'], featureKey: 'settings.users' },
    loadChildren: () => import('app/modules/settings/Ribena/users-roles/users-roles.routes').then((m) => m.usersRolesRoutes),
  },
  {
    path: 'settings/sharing-rules',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY'], featureKey: 'settings.sharing-rules' },
    loadChildren: () => import('app/modules/settings/Ribena/share-rule-creation/share-rule-creation.routes').then((m) => m.shareRuleCreationRoutes),
  },
  {
    path: 'settings/destination-services',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY'], featureKey: 'settings.destination-services' },
    loadChildren: () =>
      import('app/modules/settings/Ribena/destination-services-creation/destination-services.routes').then((m) => m.destinationServicesRoutes),
  },
  {
    path: 'settings/config',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY'], featureKey: 'settings.config' },
    loadChildren: () => import('app/modules/settings/Ribena/configuration/configuration.routes').then((m) => m.configurationRoutes),
  },
  {
    path: 'gdst-tools/master-data/trading-parties',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY'], featureKey: 'gdst.trading-parties' },
    loadChildren: () => import('app/modules/GDST-tools/master/trading-parties/trading-parties.routes').then((m) => m.tradingPartiesRoutes),
  },
  {
    path: 'gdst-tools/master-data/locations',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY'], featureKey: 'gdst.locations' },
    loadChildren: () => import('app/modules/GDST-tools/master/locations/locations.routes').then((m) => m.locationsRoutes),
  },
  {
    path: 'gdst-tools/master-data/vessels',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY'], featureKey: 'gdst.vessels' },
    loadChildren: () => import('app/modules/GDST-tools/master/vessels/vessels.routes').then((m) => m.vesselsRoutes),
  },

  {
    path: 'gdst-tools/master-data/trade-items',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY'], featureKey: 'gdst.trade-items' },
    loadChildren: () => import('app/modules/GDST-tools/master/trade-items/trade-items.routes').then((m) => m.tradeItemsRoutes),
  },
];
